/* eslint-disable no-unused-expressions */
import React from 'react';
import {Link} from 'react-router-dom';

export function getControlBeneficiary(item) {
    const project = item?.project;
    item.beneficiary = (project?.beneficiaryName || 'Brak danych') + ' - ' + (project?.beneficiaryIdentityNumber || 'Brak danych');
}

export function getControlPlace(item) {
    item.controlPlace = item.project?.place || item.project?.beneficiaryAddress;
}

export function getControlDictionaries(item) {
    //prepare data about dictionaries
    item.kind = '';
    item.controlTeam = '';
    item.dictionaryEntries?.forEach(function (value) {
        if (value.dictNumber === 1) {
            item.type = value.description;
        }
        if (value.dictNumber === 2) {
            item.mode = value.description;
        }
        if (value.dictNumber === 3) {
            item.kind += value.description + ', ';
        }
    });
    item.kind = item.kind.substr(0, (item.kind.length - 2));
}

export function formatControlTeam(controllers, teamLeader, isShortVersion = false) {
    if (!controllers || controllers.length === 0) return '';

    let team = [];
    const teamLeaderLogin = teamLeader?.login;
    const leaderSuffix = isShortVersion ? ' (K)' : ' (Kierownik zespołu)';

    // Add team leader first (if exists)
    if (teamLeaderLogin) {
        const leader = controllers.find(c => c.login === teamLeaderLogin);
        if (leader) {
            team.push(concatString([leader.firstName, leader.lastName], ' ') + leaderSuffix);
        }
    }

    // Sort other members alphabetically by last name
    const otherMembers = controllers
        .filter(c => c.login !== teamLeaderLogin)
        .sort((a, b) => {
            const lastNameA = (a.lastName || '').toLowerCase();
            const lastNameB = (b.lastName || '').toLowerCase();
            if (lastNameA === lastNameB) {
                const firstNameA = (a.firstName || '').toLowerCase();
                const firstNameB = (b.firstName || '').toLowerCase();
                return firstNameA.localeCompare(firstNameB);
            }
            return lastNameA.localeCompare(lastNameB);
        });

    otherMembers.forEach(member => {
        team.push(concatString([member.firstName, member.lastName], ' '));
    });

    return team.join(', ');
}

// Function for detail views (with full "Kierownik zespołu" designation)
export function formatControlTeamForDetails(controllers, teamLeader) {
    return formatControlTeam(controllers, teamLeader, false);
}

// Function for tables (with short "(K)" designation)
export function formatControlTeamForTable(controllers, teamLeader) {
    return formatControlTeam(controllers, teamLeader, true);
}

export function getControllingTeam(item) {
    // prepare info about control team
    item.controlTeam = formatControlTeamForDetails(item?.controllers, item?.teamLeader);
}

export function trimToEmpty(str) {
    if (str == null)
        return '';
    return str.trim();
}

export function concatString(str, separator) {
    let concatenated = '';
    str.forEach(it => concatenated += trimToEmpty(it) + separator);
    return trimToEmpty(concatenated);
}

export function getPostControlInfo(item) {
    // prepare info about post control info
	if (item.postControlDocuments) {
		item.documentType = 'Informacja';
	}else {
		item.documentType = 'Notatka';
	}
/*
    item?.postControlDocuments?.forEach(value => {
        if (value.postControlInfo !== null && value.postControlInfo !== '') {
            item.documentType = 'Informacja';
            if (value.postControlInfo.isFinalInfo) {
                item.postControlInfoFinalIssueDate = value.postControlInfo.finalInfoSendDate;
            } else {
                item.postControlInfoIssueDate = value.postControlInfo.receivedByControlledEntityDate;
                //Uwaga remarksIssueDate to inna data w rozumieniu strutktur. To co widać w info postr control z zastrzeżeniami pochodzi z objection.issueDate
                item.remarksIssueDate = customDateConversion(value.postControlInfo.objection?.issueDate);
            }
        } else {
            item.documentType = 'Notatka';
        }
    })
*/
}

export function setupPlannedControlTerm(item) {
    // prepare date of planned control from to
    item.plannedTerm = formatDate(item.dateFrom, item.dateTo);
}

export function setupControlTerm(item) {
    // prepare date of control start end
    item.term = formatDate(item.dateStart, item.dateEnd)
}


export function formatDate(dateStart, dateEnd) {
    if (dateStart !== null && dateEnd !== null) {
        return (dateStart + ' - ' + dateEnd).trim();
    } else {
        let start = dateStart === null ? '' : dateStart;
        let end = dateEnd === null ? '' : dateEnd;
        return (start + end).trim();
    }
}

export function getControlFollowUp(item) {
    // prepare follow-up Yes/No info
    if (item.followUp === true) {
        item.followUpString = 'Tak'
    } else {
        item.followUpString = 'Nie'
    }
}

export function getControlFollowUpStatus(item) {
    // prepare foll-up Status
    item.followUpStatus !== null ? item.followUpStatus = item.followUpStatus?.replace('_', ' ') : null;
}


export function getControlIsCorrection(item) {
    // prepare correction Yes/No info
    if (item.correction === true) {
        item.correctionString = 'Tak'
    } else {
        item.correctionString = 'Nie'
    }
}

export function getControlSubjects(item) {
    let subjectsList = '';
    item?.subjects?.length > 0 && item.subjects.map(sub => {
        subjectsList += `${sub.name} - ${sub.identifierTypeName}: ${sub.id}`;
        subjectsList += (item.subjects.indexOf(sub) < (item.subjects.length - 1)) ? ', ' : '';
    });
    item.subjectsList = subjectsList;
}

export function setupControlData(item) {
	//TODO: zmienic w tych funkcjach nazwy
    //for planned
    if (item) {
        getControlBeneficiary(item);

        getControlPlace(item);

        getControlDictionaries(item);

        getControllingTeam(item);

		//niepotrzebne - z backendu przychodzi konkretna wartość
        // getPostControlInfo(item);

        setupPlannedControlTerm(item);

        setupControlTerm(item);

        //for done only

        getControlFollowUp(item);

        getControlFollowUpStatus(item);

        getControlIsCorrection(item);
    }

    return item;
}

export function getExternalControlData(item) {
    if (item) {
        setupPlannedControlTerm(item);

        getControlSubjects(item)
    }

    return item;
}

export function displayLink(link, linkName, blank, event) {
    let target = blank ? '_blank' : null;
    return <Link to={link} className='links' target={target}>{linkName} </Link>
}

export function displayButton(action, name) {
    return <button className='links' onClick={action}>{name}</button>
}

export function displayInfosListTab(document, number, controlId, menuName, passDocFunct) {
    const buttons = [];

    if (document) {
		document.forEach(postDoc => {

            if (postDoc.postControlInfo) {
                let linkPath = '/' + menuName + '/' + controlId + '/post_control_info_detail/' + postDoc.postControlInfo.id;
                let linkName = postDoc.postControlInfo.isFinalInfo === true ? number + '-OST' : number + '-INF';
                buttons.push(displayLink(linkPath, linkName))
            }

            if (postDoc.postControlNote) {
                let linkOstPath = '/' + menuName + '/' + controlId + '/post_control_note_detail/' + postDoc.postControlNote.id;
                let linkOstName = number + '-NOT';
                buttons.push(displayLink(linkOstPath, linkOstName));
            }
        });

        if (passDocFunct) {
            buttons.push(displayButton(passDocFunct, 'PRZEKAZANIE DOKUMENTÓW'));
        }
    }

    return <div id='editWindowTab'>
        <div>
            {buttons}
        </div>
    </div>;
}

export function displayRemarksListTab(row, actionOst) {
    return (
        <div id='editWindowTab'>
            {displayButton(actionOst, 'INFORMACJE')}
        </div>
    )
}

export function displayFollowUpInfo(row) {
    let followUpInfo;
    followUpInfo = <div id='editWindowTab'><h5>Dotyczy kontroli {row.number}</h5>
        <div>
            <p className='mt-3 font-weight-bold'>Status wdrażania zaleceń</p>
            <p>{row.followUpStatus}</p>

            <p className='mt-3 font-weight-bold'>Notatka nt. stanu wdrażania zaleceń</p>
            <p>{row.followUpNote}</p>

        </div>
    </div>;
    return followUpInfo;
}

export const getFilterParam = (filters) => {
    const mappedFilters = filters?.map(f => {
        if (f.field === "project.beneficiaryAddress") {
            return {...f, field: "beneficiaryAddress"};
        }
        if (f.field === "project.beneficiaryName") {
            return {...f, field: "beneficiary"};
        }
        if (f.field === "project.beneficiaryIdentityNumber") {
            return {...f, field: "projectBeneficiaryIdentityNumber"};
        }
        return f;
    })
    return mappedFilters?.filter(f => f.filterValue !== undefined).map((f) => `${f.field}=${f.filterValue}&`).join('');
}

export const getColumnsWithDefaultFilterValues = (columns, filters) => {
    return columns.map((c, i) => ({...c, defaultFilter: filters[i]?.filterValue}));
};